import React from 'react';
import { useTranslation } from '../i18n';

const INSTAGRAM_URL = 'https://www.instagram.com/delyth.brides/';
const PHONE_HREF = 'tel:+256781822010';
const PHONE_DISPLAY = '+256 781 822 010';
const EMAIL_ADDRESS = 'delythug@gmail.com';

const Footer: React.FC = () => {
  const { t } = useTranslation();

  return (
    <footer className="bg-gray-900 text-white py-16">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Contact Info */}
          <div>
            <h3 className="text-xl font-semibold mb-4">{t('footer.contactUs')}</h3>
            {[1, 2, 3, 4].map((lineNumber) => (
              <p key={lineNumber} className="mb-2">
                {t(`home.contact.addressLine${lineNumber}`)}
              </p>
            ))}
            <p className="mb-2">
              {t('home.contact.phone')}: <a href={PHONE_HREF} className="text-inherit hover:text-gray-300 transition duration-300">{PHONE_DISPLAY}</a>
            </p>
            <p>
              {t('home.contact.email')}: <a href={`mailto:${EMAIL_ADDRESS}`} className="text-inherit hover:text-gray-300 transition duration-300">{EMAIL_ADDRESS}</a>
            </p>
          </div>

          {/* Hours */}
          <div>
            <h3 className="text-xl font-semibold mb-4">{t('footer.storeHours')}</h3>
            <p className="mb-2">{t('home.contact.hoursWeekdays')}</p>
            <p className="mb-2">{t('home.contact.hoursSaturday')}</p>
            <p>{t('home.contact.hoursSunday')}</p>
          </div>

          {/* Social Media */}
          <div>
            <h3 className="text-xl font-semibold mb-4">{t('footer.followUs')}</h3>
            <div className="flex">
              <a
                href={INSTAGRAM_URL}
                target="_blank"
                rel="noreferrer"
                aria-label={t('common.followInstagram')}
                className="text-gray-400 hover:text-white transition duration-300"
              >
                <svg
                  className="w-6 h-6"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d="M7.75 2h8.5A5.75 5.75 0 0 1 22 7.75v8.5A5.75 5.75 0 0 1 16.25 22h-8.5A5.75 5.75 0 0 1 2 16.25v-8.5A5.75 5.75 0 0 1 7.75 2zm0 1.5A4.25 4.25 0 0 0 3.5 7.75v8.5a4.25 4.25 0 0 0 4.25 4.25h8.5a4.25 4.25 0 0 0 4.25-4.25v-8.5a4.25 4.25 0 0 0-4.25-4.25h-8.5zm8.75 2.25a1 1 0 1 1 0 2 1 1 0 0 1 0-2zM12 6.5A5.5 5.5 0 1 1 6.5 12 5.51 5.51 0 0 1 12 6.5zm0 1.5A4 4 0 1 0 16 12a4 4 0 0 0-4-4z" />
                </svg>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-8 pt-8 text-center">
          <p>&copy; 2024 Delyth Brides. {t('footer.copyright')}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;


